// extracted by mini-css-extract-plugin
module.exports = {"componentsPciPrompt":"styles_componentsPciPrompt__10uIk"};